import React from 'react';

import Text from 'relements/build/esm/input/text';
import Radio from 'relements/build/esm/input/radio';

import styled from 'styled-components';

import { sendGoogleAnalyticsEvents } from '@src/actions/_utils';
import { GOOGLE_ANALYTICS, FIELD_TO_GA_LABEL_MAPPING } from '@src/const';
import { BOT_ENV } from './constants';

const STATUS_ACTIVE = { title: 'Active', value: true };
const STATUS_INACTIVE = { title: 'Inactive', value: false };

const TextArea = styled(Text)`
  textarea {
    max-height: 54px;
    overflow-y: auto;
    border: 1px solid
      ${(props) =>
        props.error
          ? props.theme.colors.red.haptik
          : props.theme.colors.grey.haptik};
  }
`;

export default class Advanced extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorKeys: [],
      active: STATUS_ACTIVE,
      gender: 'Male',
      companyName: '',
      botPersona: 0,
      botContext: '',
      companyContext: '',
    };
  }

  render() {
    const { active_env } = this.props.botEnv;
    const ENV_OBJ =
      active_env && BOT_ENV.hasOwnProperty(active_env.toUpperCase())
        ? BOT_ENV[active_env.toUpperCase()]
        : BOT_ENV.TEST;

    return (
      <div>
        <div className="grid-container">
          <div className="grid-label">
            * Bot deployment environment (base URL)
          </div>
          <div className="radio-wrapper">
            <Radio
              themed
              prefixClassName="env-options"
              value={ENV_OBJ}
              options={Object.values(BOT_ENV)}
              onChange={(value) =>
                this.props.handleEnvUpdate(`active_env`, value.value)
              }
            />
          </div>
          <div className="input-wrapper">
            <Text
              themed
              style={{ marginBottom: 8 }}
              className="url-input"
              placeholder={BOT_ENV.TEST.placeholder}
              value={this.props.botEnv[`base_url_${BOT_ENV.TEST.value}`]}
              onChange={(value) =>
                this.props.handleEnvUpdate(
                  `base_url_${BOT_ENV.TEST.value}`,
                  value
                )
              }
            />
            <Text
              themed
              className="url-input"
              placeholder={BOT_ENV.PRODUCTION.placeholder}
              value={this.props.botEnv[`base_url_${BOT_ENV.PRODUCTION.value}`]}
              onChange={(value) =>
                this.props.handleEnvUpdate(
                  `base_url_${BOT_ENV.PRODUCTION.value}`,
                  value
                )
              }
            />
          </div>
        </div>
        <Radio
          themed
          options={this.props.personalities}
          label="* Personality"
          value={this.props.personalities[this.state.botPersona]}
          onChange={(value) => this.onUpdate('botPersona', value.key)}
          error={this.state.errorKeys.indexOf('botPersona') > -1}
          className="bot-properties-input"
        />
        <Radio
          themed
          options={[STATUS_ACTIVE, STATUS_INACTIVE]}
          label="* Bot Status"
          className="bot-properties-input"
          value={this.state.active}
          onChange={(value) => this.onUpdate('active', value)}
          error={this.state.errorKeys.indexOf('active') > -1}
        />
        <Text
          themed
          label="* Gender"
          placeholder="Write here..."
          className="bot-properties-input"
          value={this.state.gender}
          onChange={(value) => this.onUpdate('gender', value)}
          error={this.state.errorKeys.indexOf('gender') > -1}
        />
        <Text
          themed
          label="Name of the Creator / Company"
          placeholder="(Optional) Write here..."
          className="bot-properties-input"
          value={this.state.companyName}
          onChange={(value) => this.onUpdate('companyName', value)}
        />
        <Text
          themed
          label="Name of the app"
          placeholder="(Optional) Write here..."
          className="bot-properties-input"
          value={this.state.appName}
          onChange={(value) => this.onUpdate('appName', value)}
        />
        <Text
          themed
          label="Feedback Smart Action Link"
          placeholder="(Optional) Write here..."
          className="bot-properties-input"
          value={this.state.feedbackSmartActionLink}
          onChange={(value) => this.onUpdate('feedbackSmartActionLink', value)}
        />
        <Text
          themed
          label="Company Website"
          placeholder="(Optional) Write here..."
          className="bot-properties-input"
          value={this.state.companyWebsite}
          onChange={(value) => this.onUpdate('companyWebsite', value)}
        />
        <Text
          themed
          label="Where does the bot live?"
          placeholder="(Optional) Write here..."
          className="bot-properties-input"
          value={this.state.botLocation}
          onChange={(value) => this.onUpdate('botLocation', value)}
        />
        <TextArea
          multiline
          themed
          label="Bot Description (Max 40 Words)"
          placeholder="(Optional) Describe the purpose of the bot in a few words here..."
          className="bot-properties-input"
          value={this.state.botContext}
          onChange={(value) => {
            this.onUpdate('botContext', value);
          }}
          error={this.state.errorKeys.indexOf('botContext') > -1}
        />
        <TextArea
          multiline
          themed
          label="Company Description (Max 40 Words)"
          placeholder="(Optional) Write a brief note about the Company, and the services it provides, here..."
          className="bot-properties-input"
          value={this.state.companyContext}
          onChange={(value) => this.onUpdate('companyContext', value)}
          error={this.state.errorKeys.indexOf('companyContext') > -1}
        />
      </div>
    );
  }

  onUpdate = (key, value) => {
    this.setState({ [key]: value });
    if (FIELD_TO_GA_LABEL_MAPPING[key]) {
      sendGoogleAnalyticsEvents(
        GOOGLE_ANALYTICS.CATEGORY.BOT,
        GOOGLE_ANALYTICS.EVENTS.BOT_EDIT,
        FIELD_TO_GA_LABEL_MAPPING[key],
        GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK
      );
    }
  };

  validate = () => {
    const errorKeys = [];
    const { companyContext, botContext } = this.state;
    if (companyContext && companyContext.split(' ').length > 40)
      errorKeys.push('companyContext');
    if (botContext && botContext.split(' ').length > 40)
      errorKeys.push('botContext');
    if (this.state.active === undefined) errorKeys.push('active');
    if (!this.state.gender) errorKeys.push('gender');
    if (this.state.botPersona === undefined) errorKeys.push('botPersona');

    this.setState({ errorKeys });

    return errorKeys.length === 0;
  };
}
